export default __webpack_public_path__ + "static/media/glass-cheers.1fc6e522.svg";